module.exports = __webpack_public_path__ + "img/right.8e424d91.png";